/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./statusLogs.vue?vue&type=template&id=221a80b5&scoped=true&"
import script from "./statusLogs.vue?vue&type=script&lang=js&"
export * from "./statusLogs.vue?vue&type=script&lang=js&"
import style0 from "./statusLogs.vue?vue&type=style&index=0&id=221a80b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a80b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
